"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var grid_1 = require("./grid");
var icons_1 = require("../icons");
var colors_1 = require("../util/colors");
var SuccessCheck = function () { return (react_1.default.createElement(grid_1.Container, { center: true, style: {
        height: '32px',
        width: '32px',
        backgroundColor: colors_1.colors.primary500,
        borderRadius: '100%',
    } },
    react_1.default.createElement(icons_1.NewCheck, { color: colors_1.colors.white }))); };
exports.default = SuccessCheck;
//# sourceMappingURL=SuccessCheck.js.map